import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import InsButton from "../../../components/InsButton/InsButton";
import * as microsoftTeams from "@microsoft/teams-js";
import "./Intro.scss";
import { splashscreen } from "../../../api/splashscreen";
import { setLocale } from "../../../store/actions/authActions";
import { connect } from "react-redux";
import SsoDropdown from "components/SsoDropdown/SsoDropdown";
import LogoCustomTheme from "components/Theme/Logo/LogoCustomTheme";

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // languages: [],
      // currentLocale: "fr-FR",
      api: false,
      backgroundImage: null,
    };
  }

  _redirectLogin = () => {
    this.props.history.push(`/connect/login`);
  };

  componentDidMount() {
    // this._getLocales();
    microsoftTeams.initialize(() => {
      this.props.history.push(`/connect/teams`);
    });
    splashscreen().then(
      (data) => {
        this.setState({
          api: true,
          backgroundImage:
            process.env.REACT_APP_BACKEND +
            "/uploads/splashscreen/picture/" +
            data[0]?.picture,
        });
      },
      () => {
        this.setState({
          api: true,
        });
      }
    );
  }

  // onSelectChange(event) {
  //   this.changeLocale(event.target.value);
  // }

  render() {
    const { t } = this.props;
    const { api, backgroundImage } = this.state;

    return (
      <>
        {api && (
          <div
            className="intro-bg"
            style={
              backgroundImage && { backgroundImage: `url(${backgroundImage})` }
            }
          >
            {/* <div className="select-wrapper">
              <select
                className="select-locale"
                onChange={(e) => this.onSelectChange(e)}
                value={this.state.currentLocale}
              >
                {this.state.languages.map((language) => (
                  <option key={language.locale} value={language.locale}>
                    {language.name}
                  </option>
                ))}
              </select>
            </div> */}
            <div className="intro-content">
              <LogoCustomTheme className="we-are-ll" />
              <p>
                <InsButton
                  text={t("connect")}
                  type="white"
                  link="/connect/login"
                />
              </p>
              <p>
                <InsButton
                  text={t("create_account")}
                  type="outline"
                  link="/connect/create"
                />
              </p>
              <SsoDropdown />
            </div>
          </div>
        )}
      </>
    );
  }
}

//extract data from the redux store
const mapStateToProps = (state) => ({});

// Le tableau est modifié on le modifie dans le store
const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale) => {
      dispatch(setLocale(locale));
    },
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Intro)
);
